export function DoneStep({
  groupsTotal,
  expectedGroups,
  onClose,
}: {
  /**
   * null = the scraper never reported a count (V2 WhatsApp posts `done` with
   * an empty payload — IR-1429). Only a *reported* 0 means "possibly banned".
   */
  groupsTotal: number | null;
  expectedGroups: number;
  onClose: () => void;
}) {
  let chip = null;
  if (groupsTotal === null) {
    chip = (
      <span className="iris-chip" style={{ background: "rgba(160,160,160,.2)" }}>
        group count not reported by this scraper
      </span>
    );
  } else if (groupsTotal === 0) {
    chip = (
      <span className="iris-chip" style={{ background: "rgba(255,80,80,.2)" }}>
        0 groups visible — possibly banned
      </span>
    );
  } else if (expectedGroups && groupsTotal < expectedGroups) {
    chip = (
      <span className="iris-chip" style={{ background: "rgba(255,180,0,.2)" }}>
        {groupsTotal} of {expectedGroups} groups
      </span>
    );
  }
  return (
    <div style={{ padding: 24, textAlign: "center" }}>
      <div style={{ fontSize: 48, color: "#39ff88" }}>✓</div>
      <div style={{ marginTop: 8 }}>
        {groupsTotal === null ? "Linked." : `Linked. ${groupsTotal} groups visible.`}
      </div>
      {chip}
      <button
        type="button"
        className="iris-btn iris-btn--primary"
        style={{ marginTop: 16 }}
        onClick={onClose}
      >
        Close
      </button>
    </div>
  );
}
